import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from '../../../services';

@Component({
  selector: 'app-report-image',
  templateUrl: './report-image.component.html',
  styleUrl: './report-image.component.scss',
})
export class ReportImageComponent implements OnInit {
  @Input() width = 200;
  @Input() height = 150;
  @Input() imageUrl: string;

  public src = undefined;

  constructor(private httpService: HttpService) {}

  ngOnInit() {
    if (this.imageUrl) {
      this.httpService.getAzureFile(this.imageUrl, this.getFileType(this.imageUrl)).subscribe((blob) => {
        const reader = new FileReader();
        reader.onload = () => (this.src = reader.result as string);
        reader.readAsDataURL(blob);
      });
    }
  }

  getFileType(url: string): string {
    const parts = url.split('.');
    switch (parts[parts.length - 1].toLowerCase()) {
      case 'png':
        return 'image/png';
      case 'jpg':
      case 'jpeg':
      default:
        return 'image/jpeg';
    }
  }
}
